import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWeixin } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardFooter, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const Support = () => {
  const { t } = useTranslation();
  
  return (
    <div className="container mx-auto px-4 py-2">
      <h2 className="mb-4 text-2xl font-semibold">{t("back.management.support.title")}</h2>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>{t("back.management.support.contactUs.title")}</CardTitle>
          <CardDescription>
            {t("back.management.support.contactUs.description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-3">
            <div className="flex items-center space-x-4 rounded-lg border p-4 transition-all hover:bg-muted">
              <FontAwesomeIcon
                icon={faWeixin}
                className="h-8 w-8 text-green-500"
              />
              <div>
                <h3 className="font-semibold">{t("back.management.support.contactUs.wechat.title")}</h3>
                <p className="text-sm text-muted-foreground">{t("back.management.support.contactUs.wechat.id")}</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 rounded-lg border p-4 transition-all hover:bg-muted">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="h-8 w-8 text-blue-500"
              />
              <div>
                <h3 className="font-semibold">{t("back.management.support.contactUs.email.title")}</h3>
                <a
                  href="mailto:redbirdcorptx@gmail.com"
                  className="text-sm text-blue-600 hover:underline"
                >
                  redbirdcorptx@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-4 rounded-lg border p-4 transition-all hover:bg-muted">
              <FontAwesomeIcon
                icon={faPhone}
                className="h-8 w-8 text-red-500"
              />
              <div>
                <h3 className="font-semibold">{t("back.management.support.contactUs.phone.title")}</h3>
                <a
                  href="tel:9452962608"
                  className="text-sm text-blue-600 hover:underline"
                >
                  (945) 296-2608
                </a>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>{t("back.management.support.hours.title")}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            {t("back.management.support.hours.description")}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{t("back.management.support.faq.title")}</CardTitle>
          <CardDescription>
            {t("back.management.support.faq.description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1">
              <AccordionTrigger>{t("back.management.support.faq.items.password.question")}</AccordionTrigger>
              <AccordionContent>
                {t("back.management.support.faq.items.password.answer")}
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2">
              <AccordionTrigger>{t("back.management.support.faq.items.businessInfo.question")}</AccordionTrigger>
              <AccordionContent>
                {t("back.management.support.faq.items.businessInfo.answer")}
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3">
              <AccordionTrigger>{t("back.management.support.faq.items.technicalIssue.question")}</AccordionTrigger>
              <AccordionContent>
                {t("back.management.support.faq.items.technicalIssue.answer")}
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-4">
              <AccordionTrigger>{t("back.management.support.faq.items.tutorials.question")}</AccordionTrigger>
              <AccordionContent>
                <p className="mb-2">{t("back.management.support.faq.items.tutorials.answer")}</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <a 
                      href="https://www.youtube.com/watch?v=50K-ADWXdzA" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      {t("back.management.support.faq.items.tutorials.videoLinks.posNewOrder")}
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.youtube.com/watch?v=jWdPJaQr7tI" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      {t("back.management.support.faq.items.tutorials.videoLinks.posDashboard")}
                    </a>
                  </li>
                </ul>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
        <CardFooter className="flex justify-between border-t px-6 py-4">
          <p className="text-sm text-muted-foreground">
            {t("back.management.support.faq.footer")}
          </p>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Support;
